module.exports = __webpack_public_path__ + "static/media/play-list-banner-purple.03958d05.jpg";